export enum ConsentStatus {
  SIGNED = 'SIGNED',
  EXPIRING_SOON = 'EXPIRING_SOON',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  SUPERSEDED = 'SUPERSEDED',
}

/** Banner variant for when a client and their caregiver both need to sign, but for different reasons */
export const MIXED_CONSENT_BANNER_STATUS = 'MIXED'

export type ConsentBannerStatus = Exclude<ConsentStatus, ConsentStatus.SIGNED> | typeof MIXED_CONSENT_BANNER_STATUS

/** A consent_tracking record from LyraTherapy's GET /lt/v1/episode/{episodeId}/consents */
export type ConsentTracking = {
  id: string
  assignment_id: string | null
  consent_version: string | null
  status: ConsentStatus
  signed_date: string | null
  expiration_date: string | null
  content_meta_data_name: string
  /** Lyra ID of the participant this consent belongs to (patient, caregiver, etc.) */
  recipient_id: string
  create_date: string
  update_date: string
  versions: unknown[]
}

export type GetEpisodeConsentsResponse = {
  consents: ConsentTracking[]
}
